// extracted by mini-css-extract-plugin
export default {"container":"DestinationSelection_container__-3ksq","selection":"DestinationSelection_selection__aeU71","label":"DestinationSelection_label__DeQjG"};